<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    class="modal-big"
    :title="title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="saveStructure"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-input :model="$schema.name" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.regon" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.order" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.data.code" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.epuap" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.data.address.email" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.integrationCodeOverwrite" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.bankAccountNumber" />
      </div>

      <div class="form-group col-12">
        <yes-or-no :model="$schema.isGuided" />
      </div>

      <div class="form-group col-12">
        <w-select :model="$schema.data.reportType" :values="reportTypes" @input="updateLevel" />
      </div>

      <div v-if="!loadingData" class="form-group col-12">
        <w-address-picker
          :model="$schema.data.address"
          :type-terc="false"
          :url="terytUrl"
          :woj-model="$schema.data.address.wojName"
          :pow-model="$schema.data.address.powName"
          :gmi-model="$schema.data.address.gmiName"
          :nr-model="$schema.data.address.houseNumber"
          :local-nr-model="$schema.data.address.flatNumber"
          :post-code-model="$schema.data.address.postalCode"
        />
      </div>
    </div>
  </w-modal>
</template>

<script>
import YesOrNo from '@/components/forms/document/YesOrNoRadio';
import { SchoolLevel } from '@/enums/schoolLevel.enum';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/structureNode.schema';
import { config } from '@/utils/config';

// @vuese
// Modal struktury
// @group structure
export default {
  components: { YesOrNo },
  mixins: [manageMixin('structureNode', {})],
  props: {
    // Id rodzica struktury
    parentId: { type: Number, required: false }
  },
  schema,
  data() {
    return {
      reportTypes: [
        { value: 'Szkoła podstawowa', text: 'Szkoła podstawowa', level: SchoolLevel.ELEMENTARY },
        { value: 'Liceum ogólnokształcące', text: 'Liceum ogólnokształcące', level: SchoolLevel.ABOVE_ELEMENTARY },
        { value: 'Technikum', text: 'Technikum', level: SchoolLevel.ABOVE_ELEMENTARY },
        { value: 'Szkoła policealna', text: 'Szkoła policealna', level: SchoolLevel.ABOVE_ELEMENTARY },
        {
          value: 'Szkoła specjalna przysposabiająca do pracy',
          text: 'Szkoła specjalna przysposabiająca do pracy',
          level: SchoolLevel.ABOVE_ELEMENTARY
        },
        { value: 'Szkoła branżowa I stopnia', text: 'Szkoła branżowa I stopnia', level: SchoolLevel.ABOVE_ELEMENTARY },
        {
          value: 'Szkoła branżowa II stopnia',
          text: 'Szkoła branżowa II stopnia',
          level: SchoolLevel.ABOVE_ELEMENTARY
        },
        { value: 'Kolegium', text: 'Kolegium', level: SchoolLevel.ABOVE_ELEMENTARY }
      ],
      loadingData: false,
      terytUrl: config.terytUrl
    };
  },
  computed: {
    title() {
      return this.id ? 'Edycja jednostki oświatowej' : 'Dodawanie jednostki oświatowej';
    },

    formData() {
      if (!this.id) {
        return emptyData();
      }
      const data = JSON.parse(JSON.stringify(this.stateData));
      if (!data.data) {
        data.data = { address: {} };
      }
      if (!data.data.address) {
        data.data.address = {};
      }
      data.data.reportType = data.data.reportType || null;

      data.data.address.terc =
        (data.data.address.woj || '').padStart(2, '0') +
        (data.data.address.pow || '').padStart(2, '0') +
        (data.data.address.gmi || '').padStart(2, '0');
      return data;
    }
  },
  methods: {
    // @vuese
    // Zapisuje strukturę
    saveStructure() {
      this.$schema.parentId.$setData(this.parentId);
      this.save();
    },

    // @vuese
    // Ustawia dane formularza
    setData() {
      this.loadingData = true;
      this.$schema.$setDefault();
      if (this.id) {
        const formData = this.formData;
        this.$schema.$setData(formData, undefined, true);
      }
      this.$schema.$reset();
      this.$nextTick(() => (this.loadingData = false));
    },

    // @vuese
    // Ustawia poziom jednostki zgodnie z wybraną opcją
    updateLevel(selectedSchoolType) {
      const selectedSchoolTypeOption = this.reportTypes.find(type => type.value === selectedSchoolType);
      const level = selectedSchoolTypeOption?.level;
      this.$schema.data.level.$setData(level);
    }
  }
};
</script>
